import { useState, useEffect } from 'react';
import { onSnapshot, doc } from 'firebase/firestore';

import { firestore } from '../config/firebase.config';
import pop2 from '../assets/images/pop2.png';
import button from '../assets/images/button.png';
import environments from '../utils/environments';

const { GAME_VERSION , VERSION_TARGET} = environments;

const GameUpdateModal = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [newVersion, setNewVersion] = useState(GAME_VERSION);

  const clearCaches = async () => {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
      console.log('----- all caches cleared -----');
    }

    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
      console.log('----- service worker unregistered -----');
    }
  };

  const update = async () => {
    if (loading) return;
    setLoading(true);
    let isSuccess = false;
    let retry = 0;
    const maxRetry = 10;
    while (!isSuccess && retry < maxRetry) {
      try {
        retry++;
        await clearCaches();
        console.log('clear caches!');
        isSuccess = true;
        window.location.reload(true);
      } catch (err) {
        console.error(err);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(firestore, 'system', VERSION_TARGET), (doc) => {
      if (doc.exists()) {
        const { version } = doc.data();
        if (version !== GAME_VERSION) {
          setNewVersion(version);
          setOpen(true);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  if (!open) return null;

  return (
    <div
      className="position-fixed top-0 left-0 w-100 h-100 z-3 d-flex justify-content-center align-items-center modal"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
      <div
        className="shadow-md d-flex flex-column justify-content-center gap-3"
        style={{
          maxWidth: 600,
          padding: '16px 32px',
          background: `url(${pop2})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '0% 0%',
          backgroundSize: '100% 100%',
        }}>
        <div>
          <p className="text-uppercase text-lg text-dark text-center mb-0" style={{ fontWeight: 700 }}>
            New update detected
          </p>
          <p className="text-dark text-center mb-0" style={{ fontSize: 10, fontStyle: 'italic' }}>
            Update to play
          </p>
        </div>
        <div>
          <p className="text-dark text-center mb-0">
            Current version: <span style={{ fontWeight: 700 }}>v{GAME_VERSION || '---'}</span>
          </p>
          <p className="text-dark text-center mb-0">
            New version: <span style={{ fontWeight: 700 }}>v{newVersion}</span>
          </p>
        </div>
        <button
          className="btn text-light py-2"
          onClick={update}
          disabled={loading}
          style={{
            background: `url(${button})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '0% 0%',
            backgroundSize: '100% 100%',
          }}>
          Update
        </button>
      </div>
    </div>
  );
};

export default GameUpdateModal;
